var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 60,
    viewBox: "0 0 53 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9946 2.07422L15.1429 3.75H3.78571C1.69174 3.75 0 5.42578 0 7.5C0 9.57422 1.69174 11.25 3.78571 11.25H49.2143C51.3083 11.25 53 9.57422 53 7.5C53 5.42578 51.3083 3.75 49.2143 3.75H37.8571L37.0054 2.07422C36.3665 0.796875 35.0534 0 33.6219 0H19.3781C17.9467 0 16.6335 0.796875 15.9946 2.07422ZM49.2143 15H3.78571L6.29375 54.7266C6.48304 57.6914 8.96741 60 11.9605 60H41.0395C44.0326 60 46.517 57.6914 46.7062 54.7266L49.2143 15Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.cad2bc96eef7832cd0ba31196c94e094.svg";
export { ForwardRef as ReactComponent };